import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

export default {
    namespaced: true,
    state() {
        return {

            jobs_list: [],
            current_work: null,
            details_work: null,
            
        };
    },
    actions,
    mutations,
    getters,
};
